/** Built-in role that holds the global wildcard: there is nothing to add to it. */
export const SUPER_ADMIN_ROLE = 'sf_super_admin';

/** Built-in role every new account gets, so adding to it reaches every user. */
export const DEFAULT_USER_ROLE = 'sf_user';

/** Built-in roles can have permissions added in the admin app, except super admin. */
export function canEditRole(role: { name: string; isSystem?: boolean }): boolean {
  return !role.isSystem || role.name !== SUPER_ADMIN_ROLE;
}

export function isDefaultForEveryUser(roleName: string): boolean {
  return roleName === DEFAULT_USER_ROLE;
}
